import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { NToggle, ToggleService } from '@df/ui/toggle/toggle.service';

@Component({
    selector: '[tabsLink]',
    templateUrl: './tabs-link.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsLinkComponent {
    /**
     * Tab identifier
     */
    @Input()
    tabsLink?: NToggle.TId;

    @HostBinding('class._tabsLink')
    hasClass = true;

    constructor(private toggleService: ToggleService) {}

    open() {
        if (this.tabsLink) {
            this.toggleService.open(this.tabsLink);
        }
    }
}
